import styled from 'styled-components';
import { Button } from './core';
import { Modal, ModalContent, ModalFooter, ModalHeader } from './Modal';

const UnorderedList = styled.ul`
  margin: 0;
  padding-left: 1rem;
`;

export interface RulesModalProps {
  onClose(): void;
  isOpen: boolean;
}

export function RulesModal({ onClose, isOpen }: RulesModalProps) {
  return (
    <Modal scrollable onClose={onClose} isOpen={isOpen}>
      <ModalHeader>Rules</ModalHeader>
      <ModalContent scrollable>
        <UnorderedList>
          <li>
            Fill each cell with the title of a Beatles song that's written by
            the Beatles and features on at least one of their UK studio albums,
            singles or EPs.
          </li>
          <li>
            Each song title must satisfy both the row and column criteria.
          </li>
          <li>You can't use the same song more than once.</li>
          <li>
            If you select an incorrect answer, you'll lose a life. Think
            carefully as you only have three lives!
          </li>
          <li>
            Once you've run out of lives, you still have the option to continue
            playing for fun
          </li>
          <li>
            Once the game has ended you can also reveal all possible answers for
            each tile by clicking on the tile and selecting "Reveal answers"
          </li>
        </UnorderedList>
      </ModalContent>
      <ModalFooter>
        <Button onClick={onClose}>Close</Button>
      </ModalFooter>
    </Modal>
  );
}
